/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { useStyles } from "../../../../../../styles";
import { EmailTransferObjectDto } from "../../../../../../types";
import DetailsCardItemText from "../../../DetailsCardItemText";
import DetailsCardItemTitle from "../../../DetailsCardItemTitle";

interface ISingleEmailTransferContentProps {
  card: EmailTransferObjectDto;
}

const SingleEmailTransferContent = ({
  card
}: ISingleEmailTransferContentProps) => {
  const { t } = useTranslation();

  const { paperCardItem } = useStyles();

  return (
    <div css={css(paperCardItem)}>
      <DetailsCardItemTitle title={t("Details##file format")} />
      <DetailsCardItemText textToRender={`.${card.fileFormat}`} />
    </div>
  );
};

export default SingleEmailTransferContent;
